import React from 'react';
import { useTranslation } from 'react-i18next';
import './ConversationProgress.css';

const LEGEND_ITEMS = [
  ['error', 'conversation_legend_error'],
  ['correction', 'conversation_legend_correction'],
  ['learned', 'conversation_legend_learned'],
  ['reviewed', 'conversation_legend_reviewed'],
];

const ConversationProgressLegend = () => {
  const { t } = useTranslation();
  return (
    <aside className="conversation-progress-legend" aria-label={t('conversation_highlight_legend')}>
      <span className="conversation-progress-legend__title">{t('conversation_highlights')}</span>
      <ul>
        {LEGEND_ITEMS.map(([type, key]) => {
          const label = t(key);
          return (
            <li key={type}>
              <span
                className={`conversation-highlight conversation-highlight--${type} conversation-progress-legend__swatch`}
                title={label}
                data-tooltip={label}
                aria-label={label}
                tabIndex="0"
              >Aa</span>
              <span>{label}</span>
            </li>
          );
        })}
      </ul>
    </aside>
  );
};

export default ConversationProgressLegend;
